import { Link, NavLink } from "react-router-dom";
import { Phone, MessageSquare, Calculator, FolderOpen, LogIn, Stethoscope, Briefcase } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n/I18nContext";
import LanguageToggle from "@/components/LanguageToggle";

export default function Navbar() {
  const { user } = useAuth();
  const t = useT();
  const isAttorney = user && user.role === "attorney";
  const isClaimant = user && user.role !== "admin" && user.role !== "attorney";

  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-4 lg:px-12">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <div
            className="grid h-9 w-9 place-items-center rounded-lg text-white font-display font-black"
            style={{ background: "var(--brand)" }}
          >
            A
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg font-black tracking-tight text-[#11322A]">
              Apex MVA
            </div>
            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#5C6B68]">
              NY · NJ · Hablamos español
            </div>
          </div>
        </Link>
        <nav className="hidden items-center gap-6 lg:flex">
          <NavLink to="/find-care" className="text-sm font-semibold text-[#0B1317] hover:text-[#E85D04]" data-testid="nav-find-care">
            <span className="inline-flex items-center gap-1.5"><Stethoscope className="h-4 w-4" />{t("nav.find_care") !== "nav.find_care" ? t("nav.find_care") : "Find Care"}</span>
          </NavLink>
          <NavLink to="/estimator" className="text-sm font-semibold text-[#0B1317] hover:text-[#E85D04]" data-testid="nav-estimator">
            <span className="inline-flex items-center gap-1.5"><Calculator className="h-4 w-4" />{t("nav.case_value")}</span>
          </NavLink>
          <NavLink to="/chat" className="text-sm font-semibold text-[#0B1317] hover:text-[#E85D04]" data-testid="nav-chat">
            <span className="inline-flex items-center gap-1.5"><MessageSquare className="h-4 w-4" />{t("nav.chat")}</span>
          </NavLink>
          <a href="tel:+18005551234" className="text-sm font-semibold text-[#0B1317] hover:text-[#E85D04]" data-testid="nav-phone">
            <span className="inline-flex items-center gap-1.5"><Phone className="h-4 w-4" />{t("nav.hotline")}</span>
          </a>
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <LanguageToggle />
          {isAttorney ? (
            <Link to="/attorney" className="hidden text-sm font-bold text-[#11322A] hover:text-[#E85D04] sm:inline-flex items-center gap-1.5" data-testid="nav-attorney">
              <Briefcase className="h-4 w-4" /> {t("nav.attorney_portal")}
            </Link>
          ) : isClaimant ? (
            <Link to="/my-cases" className="hidden text-sm font-bold text-[#11322A] hover:text-[#E85D04] sm:inline-flex items-center gap-1.5" data-testid="nav-my-cases">
              <FolderOpen className="h-4 w-4" /> {t("nav.my_cases")}
            </Link>
          ) : (
            <Link to="/login" className="hidden text-sm font-bold text-[#11322A] hover:text-[#E85D04] sm:inline-flex items-center gap-1.5" data-testid="nav-login">
              <LogIn className="h-4 w-4" /> {t("nav.sign_in")}
            </Link>
          )}
          <Link to="/intake" className="btn-primary text-sm" data-testid="nav-cta-review">
            {t("free_review")}
          </Link>
        </div>
      </div>
    </header>
  );
}
